import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Reservations from "@/pages/Reservations";
import BookingForm from "@/pages/BookingForm";
import Agenda from "@/pages/Agenda";
import Revenue from "@/pages/Revenue";
import Settings from "@/pages/Settings";
import Stock from "@/pages/Stock";
import DemandesWeb from "@/pages/DemandesWeb";
import AssistantBubble from "@/pages/AssistantBubble";
import Contracts from "@/pages/Contracts";
import Seo from "@/pages/Seo";
import SeoHub from "@/pages/SeoHub";
import PublicCheck from "@/pages/PublicCheck";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/disponibilite" element={<PublicCheck />} />
        <Route path="/assistant" element={<AssistantBubble />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/reservations" element={<Reservations />} />
          <Route path="/reservations/nouvelle" element={<BookingForm />} />
          <Route path="/contrats" element={<Contracts />} />
          <Route path="/seo" element={<SeoHub />} />
          <Route path="/reservations/:id" element={<BookingForm />} />
          <Route path="/ca" element={<Revenue />} />
          <Route path="/stock" element={<Stock />} />
          <Route path="/demandes" element={<DemandesWeb />} />
          <Route path="/parametres" element={<Settings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
